import React, { Fragment, useState, useEffect } from "react";
import {
    Input,
    Button,
    Label,
} from 'reactstrap';
import { Form, InputGroup } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { t } from 'i18next';
import SuccessDialog from "../../Commons/SuccessDialog";
import { CREATE_USER_REGISTRATION_FORM } from '../../../store/actions/auth';
import MineError from "../../Commons/MineError";
import { generatePassword, SPECIAL_REG, validateEmail, validatePhone } from "../../../helper/common";
import { toast } from 'react-toastify';
// import { GET_ALL_PORTAL_LANGUAGES } from "../../../store/actions/portal";
import { PROGRAM_COUNTRIES } from "../../../store/actions/newRequest";
import Select from 'react-select';
import { defaulSelectIndicatorSeparatorStyles } from "../../../constants/commons";
import { PORTAL_GROUP_BY_ID } from "../../../store/actions/management";
import { portalLogoUrl } from "../../../helper/utils";
import ReCAPTCHA from "react-google-recaptcha";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import './RegisterForm.scss';
import moment from "moment";
import { PatternFormat } from 'react-number-format';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { LOCAL_URL, PAGE_CODE } from "../../../helper/constant";
import { getJsonLanguage } from "../../../helper/i18next-utils";
import { GET_DEALER_TERMS_AND_CONDITIONS } from "../../../store/actions/user";

const pageCode = PAGE_CODE.CP_REGISTER_FORM;
const defaultShortCut = 'en-US'
const MARKET_DEALER = 'market-dealer'
const MARKET_PICKUP_LOCATION = 'market-pick-up-location'
const MARKET_TYPE_NAME = {
    [MARKET_DEALER]: t(`${pageCode}.LabelDealerNetwork`),
    [MARKET_PICKUP_LOCATION]: t(`${pageCode}.LabelSpecialMarket`)
}
const CAPTCHA_SITE_KEY = '6LfpZegqAAAAACmYTkNR1f8YRwlehl-qcgrxlyoT'
const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

export default function RegisterForm(props) {
    const { portalId, termsPrivacy, programCompanyList } = props
    const { t } = useTranslation();
    const [captchaValue, setCaptchaValue] = useState(null);
    const [item, setItem] = useState({});
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(true);
    const [registerFor, setRegisterFor] = useState(MARKET_DEALER);
    const [disabledNext, setDisabledNext] = useState(true);
    const [phoneNum, setPhoneNum] = useState('')
    const [countries, setCountries] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [phoneCode, setPhoneCode] = useState(null)
    const [phoneCodes, setPhoneCodes] = useState([]);

    const [assignSupers, setAssignSupers] = useState([]);
    const [assignUsers, setAssignUsers] = useState([]);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);
    const [resetKey, setResetKey] = useState(0);
    // const [group, setGroup] = useState({});
    // const [group2, setGroup2] = useState({});
    const [contacts, setContacts] = useState([]);
    const [allProgramLanguages, setAllProgramLanguages] = useState([]);
    const [culture, setCulture] = useState(null);
    const [openingHoursFrom, setOpeningHoursFrom] = useState(null);
    const [openingHoursTo, setOpeningHoursTo] = useState(null);
    const [openingHoursDays, setOpeningHoursDays] = useState([
        {
            day: 'Monday', from: null, to: null
        },
        {
            day: 'Tuesday', from: null, to: null
        },
        {
            day: 'Wednesday', from: null, to: null
        },
        {
            day: 'Thursday', from: null, to: null
        },
        {
            day: 'Friday', from: null, to: null
        }
    ]);
    // const usernameRef = useRef(null);
    // const firstnameRef = useRef(null);

    const dispatch = useDispatch();

    const onChangeRegisterFor = (value) => {
        setRegisterFor(value)
        setContacts([
            {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                phone: ''
            }
        ])
        setOpeningHoursFrom(null)
        setOpeningHoursTo(null)
        setOpeningHoursDays([
            {
                day: 'Monday', from: null, to: null
            },
            {
                day: 'Tuesday', from: null, to: null
            },
            {
                day: 'Wednesday', from: null, to: null
            },
            {
                day: 'Thursday', from: null, to: null
            },
            {
                day: 'Friday', from: null, to: null
            }
        ])
        let inputItem = initUser({})
        setItem(inputItem)
        setError('')
    }

    const onChangeOpeningHoursDays = (value, day, type) => {
        const currentDay = openingHoursDays.find(d => d.day === day)
        let newOpeningHoursDays;
        if (currentDay) {
            newOpeningHoursDays = openingHoursDays.map(d => 
                d.day === day ? { ...d, [type]: value } : d
            );
        } else {
            newOpeningHoursDays = [...openingHoursDays, { day, [type]: value }];
        }
        setOpeningHoursDays(newOpeningHoursDays);
    }

    const onChangeOpeningHoursDaysInput = (e, day, type) => {
        const value = e.target.value
        const currentDay = openingHoursDays.find(d => d.day === day)
        let newOpeningHoursDays;
        if (currentDay) {
            newOpeningHoursDays = openingHoursDays.map(d => 
                d.day === day ? { ...d, [type]: value } : d
            );
        } else {
            newOpeningHoursDays = [...openingHoursDays, { day, [type]: value }];
        }
        setOpeningHoursDays(newOpeningHoursDays);
    }

    const goToAgreedTermsAndConditions = async () => {
        const downloadErr = await dispatch(GET_DEALER_TERMS_AND_CONDITIONS({portalId: props.portalId}));
        if (downloadErr) {
            toast.error(downloadErr?.message)
        }
    }

    const guideLink = `${LOCAL_URL}/faqs/media/1/f3c1e4b876d3a9ad7f8dcb3943dc69b8/ErstregistrieungHändler_Teil_1.webm`


    const onShow = async () => {
        // if (props.programData?.defaultUserGroupForDealerNetwork && props.programData?.defaultUserGroupForSpecialMarket) {
            // const [group, group2] = await Promise.all([
            //     PORTAL_GROUP_BY_ID({ portalId, id: props.programData?.defaultUserGroupForDealerNetwork }),
            //     PORTAL_GROUP_BY_ID({ portalId, id: props.programData?.defaultUserGroupForSpecialMarket })
            // ]);
            // setGroup(group)
            // setGroup2(group2)
        // }
        const portalCountries = await dispatch(PROGRAM_COUNTRIES(portalId));
        let allCountries = portalCountries?.map(c => {
            if (c && c.countryInfo) {
                return {
                    label: c.countryInfo.name,
                    code: c.countryInfo.shortCut,
                    value: c.countryId,
                    regionId: c.countryInfo.regionId,
                    phonePrefix: c.countryInfo.countryCode,
                    phoneFormat: c.countryInfo.phoneFormat,
                    openingHoursDays: c.countryInfo?.openingHoursDays,
                }
            }
            return false
        })?.filter(c => c)
        if (props.allProgramLanguages?.length) {
            setAllProgramLanguages(props.allProgramLanguages);
            if (props.defaultCulture) {
                let culture = props.allProgramLanguages.find(r => r.cultureInfo?.shortCut === props.defaultCulture?.shortCut)
                if (culture) {
                    setCulture({
                        value: culture.cultureId,
                        label: culture.cultureInfo?.name
                    })
                }
                getJsonLanguage(props.defaultCulture?.shortCut || defaultShortCut, props.portalId)
            } else {
                setCulture({
                    value: props.allProgramLanguages[0]?.cultureId,
                    label: props.allProgramLanguages[0]?.cultureInfo?.name
                })
                getJsonLanguage(props.allProgramLanguages[0]?.cultureInfo?.shortCut || defaultShortCut, props.portalId)
            }
        }
        setCountries(allCountries)
        
        // let results = await Promise.all([
        //     GET_ALL_PORTAL_LANGUAGES({portalId:portalId})
        // ])
        setDisabledNext(true)
        setError('')
        setPhoneCode(null)
        setPhoneNum('')
        //
        let inputItem = props.item
        inputItem = initUser({ ...inputItem })
        Object.assign(item, inputItem)

        let pcodes = allCountries.map(c => {
            if (c.phonePrefix) {
                c.phonePrefix = c.phonePrefix.trim().replace('+', '')
            }
            return ({
                label: `+${c.phonePrefix}(${c.label})`,
                value: `${c.phonePrefix}`,
                regionId: c.regionId,
                countryId: c.value,
                phonePrefix: c.phonePrefix,
                phoneFormat: c.phoneFormat,
            })
        })
        setPhoneCodes(pcodes)

        if (item.phonePrefix) {
            let phoneCode = pcodes.find(c => c.phonePrefix === item.phonePrefix)
            if (!phoneCode) {
                phoneCode = {
                    label: `+${item.phonePrefix}`,
                    value: `${item.phonePrefix}`,
                    regionId: 0,
                    countryId: 0,
                    phonePrefix: item.phonePrefix,
                }
            }
            setPhoneCode(phoneCode)
        }
        if (item.phone) {
            let phoneNum = item.phone.replace('+', '')
            let idx = item.phonePrefix ? phoneNum.indexOf(item.phonePrefix) : -1
            if (idx == 0) {
                phoneNum = phoneNum.substring(item.phonePrefix.length)
                setPhoneNum(phoneNum)
            } else {
                setPhoneNum(phoneNum)
            }
        }

        //.filter((r, i, self) => i === self.findIndex(r1 => r1.id === r.id))
        setAllCountries(allCountries)
        setCountries(allCountries)

        setContacts([
            {
                firstName: '',
                lastName: '',
                username: '',
                email: '',
                phone: ''
            }
        ])

    }

     useEffect(() => {
        onShow();
        // loadReCaptcha(CAPTCHA_SITE_KEY);
    }, []); 

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
      };
    
      
    const initUser = (itemInput) => {
        let obj = {
            portalId: props.portalId,
            clientId: props.clientId,
            id: 0,
            userId: '',
            username: '',
            email: '',
            phonePrefix: '',
            phone: '',
            firstName: '',
            lastName: '',
            isActive: true,
            isSupervisor: false,
            isRequestManager: false,
            groupId: '',
            regionId: '',
            openingHours: '',
            wasteProducerNumber: '',
            vatId: '',
            entityName: '',
            city: '',
            postCode: '',
            addressLine1: '',
            addressLine2: '',
            dealerId: '',
            dealerName: '',
            name1: '',
            kunnr: '',
            entityId: '',
            countries: null,
            assignUsers: null,
            assignSupers: null,
            entityDisplayId: '',
            entityCity: '',
            entityAddressLine1: '',
            entityPostCode: '',
            entityVatId: '',
            ...itemInput,
        }
        return obj
    }

    const onChangeSelect = async (event, name) => {
        let { value, label } = event
        if (name === 'entityId') {
            if(label && label.includes('(')){
                item.entityName = label.split('(')[0].trim()
            }else{
                item.entityName = label
                // item.entityAddressLine1 = programCompanyList?.length && programCompanyList?.find(r => r.name === label)?.addressLine1 || ''
                // item.entityVatId = programCompanyList?.length && programCompanyList?.find(r => r.name === label)?.vatId || ''
            }
        }
        setItem({
            ...item,
            [name]: value
        })
        setError('')
        // await validate()
    }

    const onChangeInput = async (event) => {
        let { value, name } = event.target
        if (event.target.type === 'checkbox') value = event.target.checked;
        console.log('onChangeInput', name, value)
        if (name === 'username' || name === 'email') {
            value = value.toLowerCase().replace(/[\s]+/, '').replace(SPECIAL_REG, '')
        }
        if (name === 'firstName' || name === 'lastName') {
            value = value.replace(SPECIAL_REG, '').replace(/(\s\s)/g, ' ')
        }
        if (name === 'phoneNum' && value) {
            value = value.replace(/\s\s+/g, ' ');
            setPhoneNum(value)
        }
        if (name === 'acceptTerms') {
            setAcceptTerms(value)
        }
        if (name === 'acceptTermsAndConditions') {
            setAcceptTermsAndConditions(value)
        }
        setItem({
            ...item,
            [name]: value
        })
        setError('')
    }

    const onChangeContactInput = async (event, cIndex) => {
        setError('')
        let { value, name } = event.target
        if (name === 'username' || name === 'email') {
            value = value.toLowerCase().replace(/[\s]+/, '').replace(SPECIAL_REG, '')
        }
        if (name === 'firstName' || name === 'lastName') {
            value = value.replace(SPECIAL_REG, '').replace(/(\s\s)/g, ' ')
        }
        if (name === 'phone' && value) {
            value = value.replace(/\s\s+/g, ' ');
        }
        let existingContact = contacts
        existingContact[cIndex][name] = value
        setContacts([...existingContact])
        validate()
    }

    const onChangeCountries = async (selectedItems) => {
        setError('')
        item.countries = selectedItems
        item.phonePrefix = selectedItems.phonePrefix
        item.phoneFormat = selectedItems.phoneFormat
        if (selectedItems.openingHoursDays) {
            const oldOpeningHoursDays = openingHoursDays
            oldOpeningHoursDays.forEach(day => {
                const foundDay = selectedItems.openingHoursDays.find(d => d.day === day.day)
                if (foundDay?.from) {
                    day.from = foundDay.from ? foundDay.from : null
                } else {
                    day.from = null
                }
                if (foundDay?.to) {
                    day.to = foundDay.to ? foundDay.to : null
                } else {
                    day.to = null
                }
            })
            setOpeningHoursDays(oldOpeningHoursDays)
        } else {
            setOpeningHoursDays([
                {
                    day: 'Monday', from: null, to: null
                },
                {
                    day: 'Tuesday', from: null, to: null
                },
                {
                    day: 'Wednesday', from: null, to: null
                },
                {
                    day: 'Thursday', from: null, to: null
                },
                {
                    day: 'Friday', from: null, to: null
                }
            ])
        }
        setItem({
            ...item,
        })
        validate()
    }

    const onChangeEntityCountries = async (selectedItems) => {
        setError('')
        item.entityCountries = selectedItems
        setItem({
            ...item,
        })
        validate()
    }



    const onChangeLanguage = (option) => {
        setCulture(option)
        getJsonLanguage(option.shortCut || defaultShortCut, props.portalId)
        setError('')
    }

    const validate = () => {
        let {
            kunnr, name1, 
            countries, city,
            addressLine1, postCode,
            vatId, wasteProducerNumber,
            entityDisplayId, entityName, entityCity, entityAddressLine1, entityPostCode, entityVatId, entityCountries,
            openingHoursDays
        } = item
        let error = ''
        if (registerFor === MARKET_DEALER && !(entityDisplayId && entityName && entityCity && entityAddressLine1 && entityPostCode && entityVatId)) {
            error = (`${t(`${pageCode}.MsgErrorEntityRequired`)}`)
        } else if (!(kunnr && kunnr.trim())) {
            error = (`${t(`${pageCode}.MsgErrorDealerIdRequired`)}`)
        } else  if (!(name1 && name1.trim())) {
            error = (`${t(`${pageCode}.MsgErrorDealerNameRequired`)}`)
        } else if (!countries?.value) {
            error = (`${t(`${pageCode}.MsgErrorCountryRequired`)}`)
        } else if (!entityCountries?.value) {
            error = (`${t(`${pageCode}.MsgErrorCountryRequired`)}`)
        } else if (!(addressLine1 && addressLine1.trim())) {
            error = (`${t(`${pageCode}.MsgErrorAddressLineRequired`)}`)
        } else if (!(city && city.trim())) {
            error = (`${t(`${pageCode}.MsgErrorCityRequired`)}`)
        } else if (!(postCode && postCode.trim())) {
            error = (`${t(`${pageCode}.MsgErrorPostCodeRequired`)}`)
        } else if (!(wasteProducerNumber && wasteProducerNumber.trim())) {
            error = (`${t(`${pageCode}.MsgErrorWasteProducerNumberRequired`)}`)
        } else if (!(vatId && vatId.trim())) {
            error = (`${t(`${pageCode}.MsgErrorVatIdRequired`)}`)
        } else if (!(/^[A-Za-z]{2,3}\d{9}$/.test(vatId.trim()))) {
            error = (`${t(`${pageCode}.MsgErrorVatIdFormat`)}`)
        // } else if (!(openingHoursFrom && openingHoursTo)) {
        //     error = (`${t(`${pageCode}.MsgErrorOperatingHoursRequired`)}`)
        } else if (!contacts?.length ||
            (contacts[0]?.firstName?.trim() === '' && 
            contacts[0]?.lastName?.trim() === '' && 
            contacts[0]?.username?.trim() === '' && 
            contacts[0]?.email?.trim() === '' && 
            contacts[0]?.phone?.trim() === '' )) {
           error = (`${t(`${pageCode}.MsgErrorContactInfoRequired`)}`)
        } else if (contacts[0]?.firstName?.trim() === '' || 
            contacts[0]?.lastName?.trim() === '' || 
            contacts[0]?.username?.trim() === '' || 
            contacts[0]?.phone?.trim() === '' ||
            contacts[0]?.email?.trim() === '' ) {
            error = (`${t(`${pageCode}.MsgErrorContactInfoRequired`)}`)
        } else if (!validateEmail(contacts[0]?.email?.trim())) {
            error = (`${t(`${pageCode}.MsgErrorEmailFormat`)}`)
        } else if (contacts[0]?.phone?.trim() && !validatePhone(contacts[0]?.phone?.trim())) {
            error = (`${t(`${pageCode}.MsgErrorPhoneFormat`)}`)
        } else if (contacts?.length === 2 && (contacts[1]?.firstName?.trim() !== '' || 
            contacts[1]?.lastName?.trim() !== '' || 
            contacts[1]?.username?.trim() !== '' || 
            contacts[1]?.email?.trim() !== '' || 
            contacts[1]?.phone?.trim() !== '' )) {
            if (contacts[1]?.firstName?.trim() === '' ||
                contacts[1]?.lastName?.trim() === '' ||
                contacts[1]?.username?.trim() === '' ||
                contacts[1]?.email?.trim() === '' ||
                contacts[1]?.phone?.trim() === '') {
                error = (`${t(`${pageCode}.MsgErrorContactInfoRequired`)}`)
            } else if (!validateEmail(contacts[1]?.email?.trim())) {
                error = (`${t(`${pageCode}.MsgErrorEmailFormat`)}`)
            } else if (contacts[1]?.phone?.trim() && !validatePhone(contacts[1]?.phone?.trim())) {
                error = (`${t(`${pageCode}.MsgErrorPhoneFormat`)}`)
            } else if (contacts[0]?.email?.trim() === contacts[1]?.email?.trim() || contacts[0]?.username?.trim() === contacts[1]?.username?.trim()) {
                error = (`${t(`${pageCode}.MsgErrorContactsDifferent`)}`)
            }
        } else {
            error = ('')
        }


        let valid = (error === '')

        setDisabledNext(!valid)
        setError(error)

        return valid
    }


    const onNext = async (e) => {
        let cpItem = JSON.parse(JSON.stringify(item))
        if (!culture?.value) {
            toast.error(`Please select language`)
            return
        }
        // if (!group?.id && !group2?.id) {
        //     toast.error(`This portal is not configured user group for registration`)
        //     return
        // }
        if (!validate()) {
            toast.error(`${t(`${pageCode}.MsgErrorRequiredFields`)}`)
            return
        }

        // if (openingHoursTo <= openingHoursFrom) {
        //     return toast.error(`${t(`${pageCode}.MsgErrorOperatingHours`)}`)
        // }

        if (!acceptTerms) {
            toast.error(termsPrivacy && termsPrivacy.isShowTermLink ? t(`MsgErrorPleaseAcceptPrivacyPolicyTerms`) : t(`MsgErrorPleaseAcceptPrivacyPolicy`))
            return
        }

        if (!acceptTermsAndConditions) {
            toast.error(`${t(`${pageCode}.MsgErrorAcceptGeneralTermsAndConditions`)}`)
            return
        }

        e.preventDefault();
        if (!captchaValue) {
            toast.error(`${t(`${pageCode}.MsgErrorCaptchaRequired`)}`)
            return;
        }

        // Format Operating hours
        const formattedOpeningHours = openingHoursFrom && openingHoursTo 
            ? `${moment(openingHoursFrom).format('HH:mm')} - ${moment(openingHoursTo).format('HH:mm')}`
            : '';
            
        const formattedOpeningHoursDays = openingHoursDays.map(day => {
            return {
                day: day.day,
                from: day.from ? day.from : null,
                to: day.to ? day.to : null
            }
        })

        // const emptyOpeningHoursDays = openingHoursDays.filter(day => !day.from || !day.to || 
        //     (day.from && typeof day.from === 'object' && day.from.isValid() === false) || 
        //     (day.to && typeof day.to === 'object' && day.to.isValid() === false))
        const emptyOpeningHoursDays = openingHoursDays.filter(day => !day.from || !day.to)
        if (emptyOpeningHoursDays?.length > 0) {
            toast.error(`${t(`${pageCode}.MsgErrorPleaseFillAllOperatingHours`)}`)
            return
        }

        const invalidOpeningHoursDays = openingHoursDays.filter(day => {
            if (!day.from || !day.to) return true;
            
            const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return !timeRegex.test(day.from) || !timeRegex.test(day.to);
        });

        if (invalidOpeningHoursDays?.length > 0) {
            toast.error(`${t(`${pageCode}.MsgErrorInvalidOperatingHours`)}`)
            return
        }


        const password = generatePassword(10)
        let payload = {
            ...cpItem,
            portalId, 
            username: cpItem.preferredUsername,
            countries: cpItem.countries,
            phonePrefix: cpItem?.countries?.phonePrefix,
            registerFor,
            password,
            contacts,
            cultureId: culture?.value,
            openingHours: formattedOpeningHours,
            openingHoursDays: formattedOpeningHoursDays,
            entityDisplayId: cpItem.entityDisplayId,
            entityName: cpItem.entityName,
            entityCity: cpItem.entityCity,
            entityAddressLine1: cpItem.entityAddressLine1,
            entityPostCode: cpItem.entityPostCode,
            entityVatId: cpItem.entityVatId,
            entityCountries: cpItem.entityCountries,
        }
        payload.countries = payload.countries || []
        delete payload['isMailVerify']
        delete payload['isTesAccount']
        delete payload['lastLoggedIn']
        delete payload['activatedOn']
        delete payload['failedLoginCount']
        delete payload['lastFailedOn']
        delete payload['phoneNum']
        delete payload['preferredUsername']
        
        console.log('payload', payload)
        let result = await CREATE_USER_REGISTRATION_FORM(payload)
        if (result?.code) {
            if (result?.code === 'DEALER_ID_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorDealerIdExists`)}`)
            } else if (result?.code === 'DEALER_NAME_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorDealerNameExists`)}`)
            } else if (result?.code === 'VAT_ID_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorVatIdExists`)}`)
            } else if (result?.code === 'WASTE_PRODUCER_NUMBER_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorWasteProducerNumberExists`)}`)
            } else if (result?.code === 'PORTAL_USER_USERNAME_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorUsernameExists`)}`)
            } else if (result?.code === 'PORTAL_USER_EMAIL_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorEmailExists`)}`)
            } else if (result?.code === 'PORTAL_CONTACT_EMAIL_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorContactEmailExists`)}`)
            } else if (result?.code === 'PORTAL_CONTACT_PHONE_EXISTS') {
                toast.error(`${t(`${pageCode}.MsgErrorContactPhoneExists`)}`)
            } else {
                toast.error(`${t(`${pageCode}.MsgErrorRegister`)}`)
            }
        } else if (result?.id) {
            toast.success(`${t(`${pageCode}.MsgSuccessRegister`)}`)
            setItem({
                groupId: item.groupId,
                portalId
            })
            setContacts([
                {
                    firstName: '',
                    lastName: '',
                    username: '',
                    email: '',
                    phone: ''
                }
            ])
            setOpeningHoursFrom(null)
            setOpeningHoursTo(null)
            setOpeningHoursDays([
                {
                    day: 'Monday', from: null, to: null
                },
                {
                    day: 'Tuesday', from: null, to: null
                },
                {
                    day: 'Wednesday', from: null, to: null
                },
                {
                    day: 'Thursday', from: null, to: null
                },
                {
                    day: 'Friday', from: null, to: null
                }
            ])
            await onShow();
            setResetKey(prev => prev + 1);
            setAcceptTerms(false)
            setAcceptTermsAndConditions(false)
        }
    }

    const onAddContact = () => {
        const existingContact = contacts
        const newContacts = [...existingContact, {
            firstName: '',
            lastName: '',
            username: '',
            email: '',
            phone: ''
        }]
        setContacts(newContacts)
    }

    const onRemoveContact = () => {
        const existingContact = contacts
        const newContacts = existingContact.slice(0, -1)
        setContacts(newContacts)
    }




    return (
        <Fragment>
            {/* <Modal id={id} isOpen={show} keyboard={true} onOpened={onShow} centered className="register-form"> */}
                {/* <ModalHeader toggle={toggleModal} className="text-left">BMW Dealer Registration for HVB scrap recycling</ModalHeader> */}
                {/* <ModalBody> */}
                    <div key={resetKey}>
                        <div>
                        <div className="registration-header">
                            <div><img alt="sktes-logo" width="75px" src={portalLogoUrl()} /></div>
                            <div><span className="registration-title">{t(`${pageCode}.LabelPageTitle`)}</span></div>
                            <div></div>
                        </div>
                        </div>
                        <div className='row mt-4 pr-2 pl-2'>
                            <div className='col-6 mb-2'>
                                <div style={{ marginLeft: '1.438rem', fontSize: '1.1rem' }} className='v-align'>
                                    <Input type='radio' key={1} name="market"
                                    onChange={() => onChangeRegisterFor(MARKET_DEALER)}
                                    checked={registerFor === MARKET_DEALER}
                                    value='OTHER' 
                                    /><label style={{ marginLeft: '0.5rem' }}>{t(`${pageCode}.LabelDealerNetwork`)}</label>
                                </div>
                            </div>
                            <div className='col-6 mb-2'>
                                <div style={{ marginLeft: '1.438rem', fontSize: '1.1rem' }} className='v-align'>
                                    <Input type='radio' key={1} name="market"
                                    onChange={() => onChangeRegisterFor(MARKET_PICKUP_LOCATION)}
                                    checked={registerFor === MARKET_PICKUP_LOCATION}
                                    value='OTHER' 
                                    /><label style={{ marginLeft: '0.5rem' }}>{t(`${pageCode}.LabelSpecialMarket`)}</label>
                                </div>
                            </div>

                            {/* {registerFor === MARKET_PICKUP_LOCATION ? <div className='col-6 mb-2'>
                                <Label required><span className="required">Preferred Username</span></Label>
                                <Input className="cp-input-box" type="text" id="preferredUsername" placeholder="Preferred Username..."
                                    name="preferredUsername" value={item.preferredUsername} required onChange={onChangeInput} />
                            </div> : null} */}

                            {/* <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelCountry`)}</span></Label>
                                <Select className="cp-select-box"
                                        name="countries" aria-label={t(`${pageCode}.LabelCountry`)} placeholder={t(`${pageCode}.LabelCountry`)}
                                        value={item.countries}
                                        styles={{
                                            ...defaulSelectIndicatorSeparatorStyles,
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '1rem !important'
                                            })
                                        }}
                                        options={countries}
                                        onChange={onChangeCountries}
                                    />
                            </div> */}

                            {/* {registerFor === MARKET_DEALER ? <><div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelEntity`)}</span></Label>
                                <Select className="cp-select-box"
                                        isDisabled={!item.countries}
                                        name="entityId" aria-label={t(`${pageCode}.LabelEntity`)} placeholder={t(`${pageCode}.LabelSelectEntity`)}
                                        value={item.entityId ? { value: item.entityId, label: item.entityName } : null}
                                        styles={{
                                            ...defaulSelectIndicatorSeparatorStyles,
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '1rem'
                                            })
                                        }}
                                        options={programCompanyList && programCompanyList.filter(r => r?.countryInfo?.name).filter(c => {
                                            let finalServingCountries;
                                            if (c.servingCountries) 
                                              finalServingCountries = c.servingCountries.find(i => i.id === c.countryId) ? c.servingCountries : [...c.servingCountries, { id: c.countryId }];
                                            else
                                              finalServingCountries = [{ id: c.countryId }]
                                            return finalServingCountries.some(i => i.id === Number(item.countries?.value));
                                          }
                                        ).map((r) => ({ label: r.name, value: r.id }))}
                                        onChange={(event) => onChangeSelect(event, "entityId")}
                                    />
                                {(!item.countries?.value) ? <MineError message={t(`${pageCode}.LabelSelectCountryFirst`)}></MineError> : null}
                                {item?.entityId ? <div className="mt-2">
                                    {programCompanyList?.find(r => r.name === item.entityName)?.entityId && <div className="text-muted">{t(`${pageCode}.LabelEntityId`)}: {programCompanyList?.find(r => r.name === item.entityName)?.entityId}</div>}
                                    {programCompanyList?.find(r => r.name === item.entityName)?.vatId && <div className="text-muted">{t(`${pageCode}.LabelVatId`)}: {programCompanyList?.find(r => r.name === item.entityName)?.vatId}</div>}
                                </div> : null}
                            </div> 
                            </>: null} */}

                        </div>
                        <div className='row mt-3 pr-2 pl-2' style={{ borderRadius: '0.5rem', padding: '0.625rem 0' }}>

                            {/* <div className='col-6 mb-2'>
                                <Label required><span className="required">Regions</span></Label>
                                <Select className="cp-select-box"
                                        name="regionId" aria-label="Regions" placeholder="Select an option"
                                        value={{ value: item.regionId, label: item.regionName }}
                                        styles={defaulSelectIndicatorSeparatorStyles}
                                        options={regions && regions.map((r) => ({ label: r.name, value: r.id }))}
                                        onChange={(event) => onChangeSelect(event, "regionId")}
                                    />
                            </div>
                            <div className='col-6 mb-2'>
                                <Label required><span className="required">Country</span></Label>
                                <Select className="cp-select-box"
                                        name="countries" aria-label="Country" placeholder="Select an option"
                                        isDisabled={!item.regionId}
                                        value={item.countries}
                                        styles={defaulSelectIndicatorSeparatorStyles}
                                        options={countries}
                                        onChange={onChangeCountries}
                                    />
                            </div> */}


                            {/* // Dealer Data */}
                            <Label  style={{fontSize: '1.2rem', fontWeight: 'bold', marginLeft: '-0.5rem'}}><span>{t(`${pageCode}.LabelDealerData`)}</span></Label>
                            
                            <div className='row registration-contacts'>
                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelCountry`)}</span></Label>
                                <Select className="cp-select-box"
                                        name="countries" aria-label={t(`${pageCode}.LabelCountry`)} placeholder={t(`${pageCode}.LabelCountry`)}
                                        value={item.countries}
                                        styles={{
                                            ...defaulSelectIndicatorSeparatorStyles,
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '1rem !important'
                                            })
                                        }}
                                        options={countries}
                                        onChange={onChangeCountries}
                                    />
                            </div>
                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelDealerId`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="kunnr" placeholder={t(`${pageCode}.LabelDealerId`)}
                                    name="kunnr" value={item.kunnr} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>
                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelDealerName`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="name1" placeholder={t(`${pageCode}.LabelDealerName`)}
                                    name="name1" value={item.name1} required onChange={onChangeInput}
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelCity`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="city" placeholder={t(`${pageCode}.LabelCity`)}
                                    name="city" value={item.city} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelAddressLine1`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="addressLine1" placeholder={t(`${pageCode}.LabelAddressLine1`)}
                                    name="addressLine1" value={item.addressLine1} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}}/>
                            </div>

                            <div className='col-6 mb-4'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelPostCode`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="postCode" placeholder={t(`${pageCode}.LabelPostCode`)}
                                    name="postCode" value={item.postCode} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>
                            <div className='col-6 mb-4'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelVatId`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="vatId" placeholder={item?.countries?.code?.length ? `${item.countries.code}123456789` : t(`${pageCode}.LabelVatId`)}
                                    name="vatId" value={item.vatId} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>
                            <div className='col-6 mb-4'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelWasteProducerNumber`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="wasteProducerNumber" placeholder={t(`${pageCode}.LabelWasteProducerNumber`)}
                                    name="wasteProducerNumber" value={item.wasteProducerNumber} onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>
                            <div className='col-12 mb-4'>
                                <Label required><span className="required">{ t(`${pageCode}.LabelOperatingHours`)}</span></Label>
                                {DAYS_OF_WEEK.map((day, index) => (
                                    <div key={index} className="d-flex align-items-center mb-2">
                                        <div className="col-2">{t(`${pageCode}.Label${day}`)}</div>
                                        <div className="col-4 d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                {/* <TimePicker
                                                    styles={{ width: '100%' }}
                                                    defaultValue={null}
                                                    value={openingHoursDays.find(d => d.day === day)?.from }
                                                    onChange={(value) => onChangeOpeningHoursDays(value, day, 'from')}
                                                    showSecond={false}
                                                    use12Hours
                                                    focusOnOpen={true}
                                                    placeholder={t(`${pageCode}.LabelOperatingHoursFrom`)}
                                                /> */}
                                                <Input className="cp-input-box" type="text" placeholder={t(`${pageCode}.LabelOperatingHoursFrom`)}
                                                    name="from" value={openingHoursDays.find(d => d.day === day)?.from || ''} onChange={(e) => onChangeOpeningHoursDaysInput(e, day, 'from')} 
                                                    style={{fontSize: '1rem'}} />
                                            </div>
                                            <div className="mx-2">-</div>
                                            <div className="flex-grow-1">
                                                {/* <TimePicker
                                                    styles={{ width: '100%' }}
                                                    defaultValue={null}
                                                    value={openingHoursDays.find(d => d.day === day)?.to}
                                                    onChange={(value) => onChangeOpeningHoursDays(value, day, 'to')}
                                                    showSecond={false}
                                                    use12Hours
                                                    focusOnOpen={true}
                                                    placeholder={t(`${pageCode}.LabelOperatingHoursTo`)}
                                                /> */}
                                                <Input className="cp-input-box" type="text" placeholder={t(`${pageCode}.LabelOperatingHoursTo`)}
                                                    name="to" value={openingHoursDays.find(d => d.day === day)?.to || ''} onChange={(e) => onChangeOpeningHoursDaysInput(e, day, 'to')} 
                                                    style={{fontSize: '1rem'}} />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            </div>

                            <Label  style={{fontSize: '1.2rem', fontWeight: 'bold', marginTop: '0px'}}><span>{t(`${pageCode}.LabelContacts`)}</span></Label>
                            < >
                            {
                                contacts.map((contact, cIndex) => <div className="row registration-contacts" key={cIndex}>
                                    {/* <div className='col-12'><Label><span style={{fontSize: '1.1rem'}}>Contact {cIndex + 1}</span></Label></div> */}
                                    <div className='registration-contacts-item'>
                                        <Label  style={{fontSize: '1.2rem', fontWeight: 'bold', margin: '0px'}}><span>{cIndex + 1}</span></Label>
                                    </div>

                                    <div className='col-3 mb-2'>
                                        <Label required><span className="required">{t(`${pageCode}.LabelFirstName`)}</span></Label>
                                        <Input className="cp-input-box" type="text" id="firstName" placeholder={t(`${pageCode}.LabelFirstName`)}
                                            name="firstName" value={contact.firstName} onChange={(e) => onChangeContactInput(e, cIndex)} 
                                            style={{fontSize: '1rem'}} />
                                    </div>
                                    <div className='col-3 mb-2'>
                                        <Label required><span className="required">{t(`${pageCode}.LabelLastName`)}</span></Label>
                                        <Input className="cp-input-box" type="text" id="lastName" placeholder={t(`${pageCode}.LabelLastName`)}
                                            name="lastName" value={contact.lastName} onChange={(e) => onChangeContactInput(e, cIndex)} 
                                            style={{fontSize: '1rem'}} />
                                    </div>

                                    <div className='col-6 mb-2'>
                                        <Label required><span className="required">{t(`${pageCode}.LabelPreferredUsername`)}</span></Label>
                                        <Input className="cp-input-box" type="text" id="username" placeholder={t(`${pageCode}.LabelPreferredUsername`)}
                                            name="username" value={contact.username} onChange={(e) => onChangeContactInput(e, cIndex)} 
                                            style={{fontSize: '1rem'}} />
                                    </div>
                                    
                                    <div className='col-6 mb-2'>
                                        <Label required><span className="required">{t(`${pageCode}.LabelPhoneNumber`)}</span></Label>
                                        {/* <Input className="cp-input-box" type="text" id="phone" placeholder="Phone Number..."
                                            name="phone" value={contact.phone} onChange={(e) => onChangeContactInput(e, cIndex)} 
                                            style={{fontSize: '1rem'}} /> */}
                                        <Form.Group controlId="phone">
                                            <InputGroup>
                                                <Form.Control disabled size="lg" name="phonePrefix" type="text" placeholder="Code" value={item?.countries?.phonePrefix ? "+"+item?.countries?.phonePrefix : ''} className="cp-select-box cp-select-group" style={{ height: '3rem', width: '3.125rem', padding: '0.188rem 0.313rem', maxWidth: '3.125rem' }} />
                                                {/* <Form.Control  size="lg" name="phone" type="text" placeholder="Phone" className="phone-group" value={contact.phone} onChange={(e) => onChangeContactInput(e, cIndex)} maxLength={64} style={{ height: '3rem' }} /> */}
                                                <PatternFormat className="form-control cp-input-box" disabled={!item.countries} format={item?.countries?.phoneFormat } mask="_" name="phone" value={contact.phone} onChange={(e) => onChangeContactInput(e, cIndex)} />
                                                {/* <PatternFormat aria-label="Number" className="form-control" placeholder="Number" mask="_" name="phone"
                                                    format={item.phoneFormat || ''} value={item.phone} onChange={(e) => this.onEventChangeItems(e, key, 'phone')} /> */}
                                            </InputGroup>
                                        </Form.Group>
                                    </div>
                                    <div className='col-6 mb-2'>
                                        <Label required><span className="required">{t(`${pageCode}.LabelEmail`)}</span></Label>
                                        <Input className="cp-input-box" type="text" id="email" placeholder={t(`${pageCode}.LabelEmail`)}
                                            name="email" value={contact.email} onChange={(e) => onChangeContactInput(e, cIndex)} 
                                            style={{fontSize: '1rem'}} />
                                    </div> 
                                </div>)
                            }   
                            {contacts?.length && contacts?.length < 2 ? <Button color="primary" className="mb-2 d-block mx-auto" type="button" onClick={(e) => onAddContact(e)}>
                            {t(`${pageCode}.LabelAddSecondContact`)}</Button> : null }
                            {contacts?.length && contacts?.length === 2 ? <Button color="primary" className="mb-2 d-block mx-auto" type="button" onClick={(e) => onRemoveContact(e)}>
                            {t(`${pageCode}.LabelRemoveSecondContact`)}</Button> : null }
                            </>


                            {registerFor === MARKET_DEALER ?
                            <>
                            <Label  style={{fontSize: '1.2rem', fontWeight: 'bold', marginLeft: '-0.5rem'}}><span>{t(`${pageCode}.LabelOwnerData`)}</span></Label>

                            <div className='row registration-contacts'>

                            <Label style={{textAlign: 'center'}}><span style={{color: 'red'}}>{t(`${pageCode}.LabelOwnerNotice`)}</span></Label>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelCountry`)}</span></Label>
                                <Select className="cp-select-box"
                                        name="countries" aria-label={t(`${pageCode}.LabelCountry`)} placeholder={t(`${pageCode}.LabelCountry`)}
                                        value={item.entityCountries}
                                        styles={{
                                            ...defaulSelectIndicatorSeparatorStyles,
                                            placeholder: (provided) => ({
                                                ...provided,
                                                fontSize: '1rem !important'
                                            })
                                        }}
                                        options={countries}
                                        onChange={onChangeEntityCountries}
                                    />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelEntityId`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityDisplayId" placeholder={t(`${pageCode}.LabelEntityId`)}
                                    name="entityDisplayId" value={item.entityDisplayId} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelOwnerName`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityName" placeholder={t(`${pageCode}.LabelOwnerName`)}
                                    name="entityName" value={item.entityName} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelCity`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityCity" placeholder={t(`${pageCode}.LabelCity`)}
                                    name="entityCity" value={item.entityCity} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelAddressLine1`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityAddressLine1" placeholder={t(`${pageCode}.LabelAddressLine1`)}
                                    name="entityAddressLine1" value={item.entityAddressLine1} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelPostCode`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityPostCode" placeholder={t(`${pageCode}.LabelPostCode`)}
                                    name="entityPostCode" value={item.entityPostCode} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            <div className='col-6 mb-2'>
                                <Label required><span className="required">{t(`${pageCode}.LabelVatId`)}</span></Label>
                                <Input className="cp-input-box" type="text" id="entityVatId" placeholder={t(`${pageCode}.LabelVatId`)}
                                    name="entityVatId" value={item.entityVatId} required onChange={onChangeInput} 
                                    style={{fontSize: '1rem'}} />
                            </div>

                            {/* <div style={{borderBottom: '0.063rem solid #000', marginTop: '1.25rem', marginBottom: '1.25rem'}}></div> */}
                            
                            </div>
                            </> : null}

                            <div className="row mt-4">
                                <div className='col-6 mb-2'>
                                    {/* <label className="accept-term">
                                        <input type='checkbox' className='customCheckbox' name="acceptTerms" onChange={onChangeInput} checked={acceptTerms} />
                                        <span className="accept-term required">I Accept Privacy Policy {termsPrivacy && termsPrivacy.isShowTermLink && "and Terms"}</span>
                                    </label> */}
                                    <label className="accept-term">
                                            <input type='checkbox' className='customCheckbox' name="acceptTerms"
                                                onChange={onChangeInput} /> <span className="accept-term required">
                                                <span className="accept-term">{t('LabelAccept')} <a className='lnk-btn' style={{ textDecoration: 'none', fontSize: '1rem' }} rel="noopener noreferrer" href="https://www.sktes.com/data-privacy" target="_blank">{t('NavLinkPolicy')} </a>{t('LabelAn')}
                                                    {/* {(termsPrivacy && termsPrivacy.isShowTermLink) ? (
                                                        <span>{t('LabelAnd')} <a className='lnk-btn' style={{ textDecoration: 'none', fontSize: '1rem' }} href={`/terms?pId=${props.portalId}`} target="_blank" rel="noopener noreferrer">{t('NavLinkTerm')} </a></span>
                                                    ) : null} */}
                                                </span>
                                            </span></label>
                                    <label className="accept-term">
                                            <input type='checkbox' className='customCheckbox' name="acceptTermsAndConditions"
                                                onChange={onChangeInput} /> <span className="accept-term required">
                                                <span className="accept-term"> {t('LabelAccept')} 
                                                <span> <a className='lnk-btn' style={{ textDecoration: 'none', fontSize: '1rem' }} href="javascript:void(0)" rel="noopener noreferrer" onClick={() => goToAgreedTermsAndConditions()}>{t('NavLinkGeneralTermsAndConditions')} </a> {t('LabelAn')} </span>
                                                </span>
                                            </span></label>
                                </div>
                                <div className='col-6 mb-2'>

                                    <div className="col-12 mb-2 text-center">
                                        <ReCAPTCHA sitekey={CAPTCHA_SITE_KEY} onChange={handleCaptchaChange} />
                                    </div>

                                    <Button style={{borderRadius: '0.5rem'}} color="primary" size="lg" className="btn-block" type="button" onClick={(e) => onNext(e)}>
                                        {t(`${pageCode}.LabelSubmit`)}</Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="language-select" style={{
                        position: 'absolute',
                        top: '1.25rem',
                        right: '1.25rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.625rem'
                    }}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faGlobe} className="mr-2" />
                            <Label className="mb-0 mr-2">{t(`${pageCode}.LabelSelectLanguage`)}</Label>
                            <Select
                                className="cp-select-box"
                                name="language" 
                                aria-label={t(`${pageCode}.LabelSelectLanguage`)}
                                placeholder={t(`${pageCode}.LabelSelectLanguage`)}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minWidth: '7.5rem',
                                        borderRadius: '0.25rem',
                                        borderColor: '#ced4da'
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        fontSize: '1rem',
                                        color: '#6c757d'
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? '#007bff' : 'white',
                                        color: state.isSelected ? 'white' : 'black',
                                        '&:hover': {
                                            backgroundColor: state.isSelected ? '#0056b3' : '#f8f9fa'
                                        }
                                    })
                                }}
                                options={allProgramLanguages?.length ? allProgramLanguages.map(r => ({ 
                                    value: r.cultureId, 
                                    label: r.cultureInfo?.name, 
                                    shortCut: r.cultureInfo?.shortCut 
                                })) : []}
                                value={culture}
                                onChange={onChangeLanguage}
                            />
                        </div>
                        <div className="d-flex align-items-center">
                            <a 
                                href={guideLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex align-items-center text-decoration-none"
                                style={{color: 'inherit'}}
                            >
                                <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
                                <Label className="mb-0">{t(`${pageCode}.LabelRaiseCollectionRequestGuide`)}</Label>
                            </a>
                        </div>
                    </div>

                    {(error) ? <MineError message={error}></MineError> : null}
                    <br />
                {/* </ModalBody> */}
            {/* </Modal> */}

            {(success) ? (
                <SuccessDialog id={'dialog-forgot-username-success'} content={t('TxtForgotUsernameSuccess')} onHide={()=> (props.onHide && props.onHide())}></SuccessDialog>
            ) : null}
        </Fragment>
    );
}